const myStyles = theme => ({
  picker: {
    position: "absolute",

    [theme.breakpoints.down("xs")]: {
      maxWidth: "100%",
      marginLeft: 5,
      right:5,
      bottom: "65px"
    },
    [theme.breakpoints.up("sm")]: {
      maxWidth: "350px",
      bottom: "130px",
      right: "30px",
      marginLeft: "30px"
    }
  }
});

export default myStyles;
